import styled from 'styled-components';

export const UnlockChoiceOption = styled.div`
  display: flex;
  background: var(--color-surface-modal);
  height: 95px;
  padding: 10px;
  gap: 0;
  border-radius: 5px 0 0 0;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;

  .title {
    text-align: left;
    color: var(--color-text-muted);
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 100%; /* 12px */
    padding: 0 0 10px;
  }

  .price {
    font-family: General Sans;
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    text-align: left;
  }

  .description {
    font-family: General Sans;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    text-align: left;
  }
`;
